import { InputSizes } from '../../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

type EyeIconProps = {
  size: InputSizes;
};

const EyeIcon = (props: EyeIconProps) => {
  const { size } = props;
  return (
    <svg
      {...stylex.props(styles.base, styles[size])}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        {...stylex.props(styles.base)}
        clipRule="evenodd"
        d="M12.0008 5.75C7.69333 5.75 4.03645 8.54374 2.74697 12.4202C2.72918 12.4736 2.7292 12.5318 2.74702 12.5852C4.0381 16.4589 7.69358 19.25 11.999 19.25C16.3064 19.25 19.9633 16.4563 21.2528 12.5798C21.2706 12.5264 21.2706 12.4682 21.2528 12.4148C19.9617 8.54113 16.3062 5.75 12.0008 5.75ZM1.32366 11.9467C2.81091 7.47571 7.02816 4.25 12.0008 4.25C16.9711 4.25 21.1867 7.47271 22.6758 11.9405C22.7961 12.3015 22.7962 12.6922 22.6761 13.0533C21.1889 17.5243 16.9716 20.75 11.999 20.75C7.02872 20.75 2.81308 17.5273 1.32398 13.0595C1.20364 12.6985 1.20353 12.3078 1.32366 11.9467ZM12 10.25C10.7573 10.25 9.74995 11.2574 9.74995 12.5C9.74995 13.7426 10.7573 14.75 12 14.75C13.2426 14.75 14.25 13.7426 14.25 12.5C14.25 11.2574 13.2426 10.25 12 10.25ZM8.24995 12.5C8.24995 10.4289 9.92888 8.75 12 8.75C14.071 8.75 15.75 10.4289 15.75 12.5C15.75 14.5711 14.071 16.25 12 16.25C9.92888 16.25 8.24995 14.5711 8.24995 12.5Z"
        fill="#1D252D"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default EyeIcon;
